import { ContextProvider } from "@lit/context";
import { css, html, LitElement } from "lit";
import { tvrnServiceCtx } from "#app/context.ts";
import { WithGlobalStylesheet } from "#app/mixins/with-global-stylesheet.ts";
import { TvrnService } from "#app/tvrn-service.ts";

export class TvrnAppElement extends WithGlobalStylesheet(LitElement) {
  static override styles = css`
    :host {
      display: contents;
    }
  `;

  constructor() {
    super();

    this.attachInternals().role = "presentation";

    new ContextProvider(this, {
      context: tvrnServiceCtx,
      initialValue: new TvrnService(),
    });

    console.info(`tavernier.app ${import.meta.env.TVRN_VERSION}`);
  }

  override render(): unknown {
    return html`<slot></slot>`;
  }
}

export const TAG_NAME = "tvrn-app" as const;

declare global {
  interface HTMLElementTagNameMap {
    [TAG_NAME]: TvrnAppElement;
  }
}

if (!Object.is(customElements.get(TAG_NAME), TvrnAppElement)) {
  customElements.define(TAG_NAME, TvrnAppElement);
}
